import AppDevice from "../Class/device";

/**
 *
 * @param {Array<Blob>} files
 */
const ZipCreatorStudy = (files) => {
    console.log(files)
  console.log(files.length);
};

/**
 * 
 * @param {Estudio} estudio
 */
const ZipStudy = async (estudio) => {
  const study = await fetch(`${AppDevice.ServerUrl}/study/${estudio.ID}`)
  const data = await study.json()
  const files = []
  data.SERIES.forEach(element => {
    const f = element.FILES
    files.push(...f)
  });
  ZipCreatorStudy(files)
};

const zipcreator = {
    ZipCreatorStudy,
    ZipStudy,
}
export default zipcreator
